/**
 * Módulo de clientes — CRUD completo con nombre de método getById personalizado
 */

import { createCrudMethods } from '../base/crudMethods';

/**
 * Crea el módulo de clientes
 *
 * @param {Object} deps - Dependencias inyectadas
 * @param {Function} deps.authenticatedRequest - Función de request autenticada
 * @returns {Object} Métodos del módulo clientes
 */
export function createClientesModule({ authenticatedRequest }) {
  return {
    ...createCrudMethods(
      {
        endpoint: '/api/clientes',
        entityName: 'cliente',
        methodNames: { getById: 'getCliente' }
      },
      { authenticatedRequest }
    )
  };
}
